import { ApiClient } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import {
  GetVoteTransactionResponseType,
  GetActivityResponseType,
  GetVoteRankingResponseType
} from '@/entities';

export const getVoteTransaction = async (
  tokenAmount: number,
  projectHash: string
) => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetVoteTransactionResponseType>(
    `${window.config.api_endpoint}/vote/transaction?token_amount=${tokenAmount}&project_address=${projectHash}`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const getVotesActivity = async (
  page?: number,
  pageSize?: number,
) => {
  const { data, error, loading, httpCode } =  await ApiClient.get<GetActivityResponseType>(
    `${window.config.api_endpoint}/vote/activity?page_size=${pageSize}&page=${page}`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const getVotesRanking = async () => {
  const { data, error, loading, httpCode } = await ApiClient.get<GetVoteRankingResponseType>(
    `${window.config.api_endpoint}/vote/ranking`,
    WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};
